module.exports = __webpack_public_path__ + "media/site/images/key-features/screenshots/desktop-holiday-work-schedules@2x-623fee4a901c5b1cf1fe32c0f8171362.png";